import * as yup from 'yup';

import type { ChipPropsColorOverrides } from '@mui/material';
import type { OverridableStringUnion } from '@mui/types';

export enum NOTIFICATION_LEVELS_NAMES {
    critical = 'critical',
    warning = 'warning',
    info = 'info',
}

export const notificationValidationSchema = yup.object({
    title: yup.string().trim().required('Title required'),
    text: yup
        .string()
        .trim()
        .test('not-empty', 'Text required', (value) => {
            if (!value) return false; // Empty check
            const strippedValue = value.replace(/<\/?[^>]+(>|$)/g, '').trim(); // Remove HTML tags
            return strippedValue.length > 0; // Ensure text remains
        })
        .required('Text required'),
    show_from: yup.string().trim().required('Time required'),
    show_to: yup.string().trim().required('Time required'),
    level: yup.mixed().oneOf([NOTIFICATION_LEVELS_NAMES.critical, NOTIFICATION_LEVELS_NAMES.warning, NOTIFICATION_LEVELS_NAMES.info]),
});

export const NEW_NOTIFICATION_EVENT_NAME = 'NEW_NOTIFICATION_EVENT';
export const NO_NOTIFICATION_ID = 'no-notification';

export const NOTIFICATION_LEVELS: (keyof typeof NOTIFICATION_LEVELS_NAMES)[] = [
    NOTIFICATION_LEVELS_NAMES.critical,
    NOTIFICATION_LEVELS_NAMES.warning,
    NOTIFICATION_LEVELS_NAMES.info,
];

export const notificationColors: Record<
    keyof typeof NOTIFICATION_LEVELS_NAMES,
    OverridableStringUnion<'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning', ChipPropsColorOverrides>
> = {
    [NOTIFICATION_LEVELS_NAMES.critical]: 'error',
    [NOTIFICATION_LEVELS_NAMES.warning]: 'warning',
    [NOTIFICATION_LEVELS_NAMES.info]: 'info',
};
